import { render, staticRenderFns } from "./incident.vue?vue&type=template&id=0df20ae8"
import script from "./incident.vue?vue&type=script&lang=js"
export * from "./incident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports